<template>
  <div class="mt-3">
    <div class="flat-card">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h6 class="mb-0" style="font-weight:600;color:#0f172a;">Feature Flags</h6>
          <small class="text-secondary">Toggle platform features without a deploy. Changes take effect immediately.</small>
        </div>
      </div>

      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border text-secondary" role="status"></div>
      </div>

      <div v-else>
        <div
          v-for="flag in flags"
          :key="flag.key"
          class="d-flex align-items-center justify-content-between py-3 border-bottom"
        >
          <div class="mr-3">
            <div class="font-weight-bold" style="font-size:.9rem;color:#0f172a;">{{ flag.label }}</div>
            <small class="text-secondary">{{ flag.description }}</small>
          </div>
          <div class="d-flex align-items-center" style="flex-shrink:0;">
            <span
              :class="['pill mr-3', flag.enabled ? 'pill-primary' : 'pill-secondary']"
            >
              {{ flag.enabled ? 'ON' : 'OFF' }}
            </span>
            <div class="custom-control custom-switch mb-0">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="'flag-' + flag.key"
                :checked="flag.enabled"
                :disabled="toggling === flag.key"
                @change="toggle(flag)"
              />
              <label class="custom-control-label" :for="'flag-' + flag.key"></label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AdminFeatureFlags',

  data() {
    return {
      loading: false,
      toggling: null,
      flags: [],
    };
  },

  mounted() {
    this.fetch();
  },

  methods: {
    async fetch() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/admin/feature-flags');
        this.flags = data;
      } finally {
        this.loading = false;
      }
    },

    async toggle(flag) {
      this.toggling = flag.key;
      try {
        const { data } = await axios.post(`/api/admin/feature-flags/${flag.key}`);
        flag.enabled = data.enabled;
        this.$toasts.push({
          message: `${flag.label} turned ${data.enabled ? 'ON' : 'OFF'}`,
          type: data.enabled ? 'success' : 'info',
        });
      } catch (e) {
        this.$toasts.push({ message: 'Failed to toggle flag', type: 'error' });
      } finally {
        this.toggling = null;
      }
    },
  },
};
</script>

<style scoped>
.flat-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 14px;
  padding: 20px;
}
.pill {
  display: inline-block;
  font-size: .7rem;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 20px;
}
.pill-primary { background: rgba(13,110,253,.1); color: #0d6efd; }
.pill-secondary { background: #f1f5f9; color: #64748b; }
</style>
